var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "sc-24603e9f-2 guUUPN",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.685 12.427c.75 0 1.41-.41 1.75-1.03l3.446-5.917a.997.997 0 0 0-.87-1.48H5.735l-.673-1.228a1 1 0 0 0-.877-.52H2.857a.865.865 0 0 0-.865.874.883.883 0 0 0 .883.874h1.126l3.6 7.59-1.35 2.44c-.73 1.34.23 2.406 1.75 2.406h11.282a.718.718 0 0 0 0-1.436H7.336l1.235-2.573h8.114ZM6.181 5.284h14.147L17.063 11H8.88L6.181 5.284ZM8.451 18a2.45 2.45 0 1 1 0 4.9 2.45 2.45 0 0 1 0-4.9Zm0 1.3a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Zm9-1.3a2.45 2.45 0 1 1 0 4.9 2.45 2.45 0 0 1 0-4.9Zm0 1.3a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.d4512b3fcd70ef3b46e833b2d6feb6c0.svg";
export { ForwardRef as ReactComponent };